module.exports = __webpack_public_path__ + "wxMicroService/img/4.8f79af33.png";